<template>
    <div
        class="search-option-toggle px-3 px-md-0 d-flex align-items-center justify-content-around flex-grow-1"
        :class="{ 'feature-inactive': searchOption.featureInactive, 'search-option-toggle--active': isSelected }"
        @click="handleToggle"
    >
        <SearchTypeIcon
            class="ml-1 mr-3 mr-md-1 text-large search-option-toggle__icon"
            :searchType="searchOption.searchType"
        />
        <span class="text-normal-small text-normal-small--wide">{{ $t(searchOption.optionName) }} </span>

        <div class="toggle-container ml-1" @click.stop="handleToggle">
            <label class="toggle-switch">
                <input
                    name="toggle-switch"
                    type="checkbox"
                    :checked="isToggleEnabled"
                    @change="handleToggle"
                    @click.stop
                />
                <span class="toggle-slider"></span>
            </label>
        </div>
    </div>
</template>
<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTypeIcon from '../SearchTypeIcon.vue';
import { ISearchOption } from './searchOptions/SearchOptionModel';
import { ITag } from '../TagModel';

const searchModule = namespace('search');

@Component({ components: { SearchTypeIcon } })
export default class SearchOptionToggle extends Vue {
    @Prop()
    public searchOption!: ISearchOption;

    @Prop()
    public isSelected!: boolean;

    @searchModule.Getter('searchTags')
    private searchTags!: ITag[];

    public get isToggleEnabled(): boolean {
        return this.searchTags.some((tag: ITag) => tag.searchType === this.searchOption.searchType);
    }

    @Emit('toggleChanged')
    public handleToggle(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return !this.isToggleEnabled;
    }
}
</script>

<style lang="scss" scoped>
.search-option-toggle {
    overflow: hidden;
    white-space: nowrap;
    background-color: transparent;
    color: $background-color;
    height: 3.5rem;

    @include media-breakpoint-up(md) {
        border: $card-border;
        color: $card-text-color;
        background-color: $card-background-color;
        box-shadow: 0.05rem 0.05rem 0.25rem 0.05rem rgba(54, 79, 140, 0.25);
        border-radius: $default-border-radius;
        justify-content: space-around;
        &:hover {
            box-shadow: $box-shadow-hover;
        }
    }
    @include media-breakpoint-down(sm) {
        justify-content: space-around;
    }
    &:hover {
        cursor: pointer;
    }

    &--active {
        background-color: $side-menu-selected-color;
        @include media-breakpoint-up(md) {
            box-shadow: none;
            color: $brand-color;
            background-color: $card-background-color;
            border-bottom: 0.15rem solid $brand-color;
        }
        &:hover {
            box-shadow: none;
            cursor: default;
        }
    }
}

.search-option-toggle__icon {
    font-size: $font-size-medium;
    height: 1.5rem;
}

.search-option-toggle__amount {
    position: absolute;
    top: 0.5rem;
}

.text-normal-small {
    @include media-breakpoint-down(sm) {
        flex-grow: 1;
    }
}

.toggle-container {
    display: flex;
    align-items: center;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    margin: 0;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 24px;
    border: 1px solid gray;

    &:before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: 0.3s;
        border-radius: 50%;
    }
}

input:checked + .toggle-slider {
    background-color: $brand-color;
}

input:checked + .toggle-slider:before {
    transform: translateX(20px);
}

input:focus + .toggle-slider {
    box-shadow: 0 0 1px $brand-color;
}
</style>
